import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function CustomScrollRestoration() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const lastLocationRef = useRef({ pathname: location.pathname, page: new URLSearchParams(location.search).get('page') });

  useEffect(() => {
    const currentPage = new URLSearchParams(location.search).get('page');
    const { pathname: lastPathname, page: lastPage } = lastLocationRef.current;

    if (location.pathname !== lastPathname || currentPage !== lastPage) {
      if (navigationType !== 'POP') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      } else {
        const scrollPosition = sessionStorage.getItem(`scrollPosition-${location.pathname}-${currentPage}`);
        if (scrollPosition) {
          window.scrollTo(
            {
              top: 0,
              left: parseInt(scrollPosition, 10),
              behavior: 'instant'
            });
        }
      }
      lastLocationRef.current = { pathname: location.pathname, page: currentPage };
    }

    const handleBeforeUnload = () => {
      sessionStorage.setItem(
        `scrollPosition-${location.pathname}-${currentPage}`,
        window.scrollY.toString()
      );
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location, navigationType]);

  return null;
}